import { Controller } from "@hotwired/stimulus"

// Fires a toast from a Turbo Stream response, then removes itself. Lets a
// controller render `shared/toast_trigger` in a stream to surface a toast
// (e.g. the Undo affordance after dismissing a thread).
export default class extends Controller {
  static values = {
    message: String,
    kind: { type: String, default: "notice" },
    action: { type: Object, default: {} }
  }

  connect() {
    const action = this.actionValue?.url ? this.actionValue : null
    window.toast(this.messageValue, { kind: this.kindValue, action })
    this.element.remove()
  }
}
